import { observable } from "mobx";
import Model from "@app/state/model/base";

export default class User extends Model {
    @observable _id = undefined;
    @observable fullName = undefined;
    @observable avatar = undefined;
}
